import { Resource } from "i18next";
import t from "../../locales/sv.json";

export default t as Resource;
